import { Suspense } from "react";
import {
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
  styled,
} from "@mui/material";
import { Clear } from "@mui/icons-material";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

import introductionImage from "assets/images/introduction.png";

import { ExampleProjects } from "components/introduction/ExampleProjects";
import { ExampleProjectsSkeleton } from "components/skeletons/ExampleProjectsSkeleton";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";

interface Props {
  isDialogOpen: boolean;
  onCloseDialog: () => void;
}

export function IntroductionDialog(props: Props) {
  const { isDialogOpen, onCloseDialog } = props;
  const { t } = useTranslation();

  // const introductionProjects = [
  //   {
  //     id: 1,
  //     location: "Sint-Gillis-Waas",
  //     title: "Verkavelingsproject in Sint-Gillis-Waas",
  //     url: "https://projecttool.toepassingen.vmm.vlaanderen.be/0f2b22e5-5b03-405c-b7a2-918b9d036482/measures?lat=51.226271489057105&lon=4.113087058067323&zoom=19",
  //   },
  //   {
  //     id: 2,
  //     location: "Merelbeke",
  //     title: "Aanleg klimaatbestendig plein in Merelbeke",
  //     url: "https://projecttool.toepassingen.vmm.vlaanderen.be/086f7754-e16d-42b3-8c45-2338608ad5e9/measures?lat=51.01462357246836&lon=3.757026978956782&zoom=19",
  //   },
  //   {
  //     id: 3,
  //     location: "Mechelen",
  //     title: "Herinrichting van een straat in Mechelen",
  //     url: "https://projecttool.toepassingen.vmm.vlaanderen.be/938c08a8-7f18-49ee-9957-aef3e08837ff/measures?lat=51.03327784649194&lon=4.498538959334094&zoom=19",
  //   },
  //   {
  //     id: 4,
  //     location: "Turnhout",
  //     title:
  //       "Mitigeren van droogte en wateroverlast door bufferbekens in Turnhout",
  //     url: "https://projecttool.toepassingen.vmm.vlaanderen.be/3e938adf-b770-4954-9963-113b11677e3b/measures?lat=51.28873493041018&lon=4.916253089904786&zoom=15",
  //   },
  //   {
  //     id: 5,
  //     location: "Roeselare",
  //     title:
  //       "Klimaatbestendig bedrijventerrein met groenblauwe ruimte in Roeselare",
  //     url: "https://projecttool.toepassingen.vmm.vlaanderen.be/ae1ba8b6-8f93-403b-ab4e-5959ff318c0a/measures?lat=50.975737302218185&lon=3.155885641134395&zoom=16",
  //   },
  // ];
  return (
    <StyledDialog
      open={isDialogOpen}
      onClose={onCloseDialog}
      maxWidth="md"
      fullWidth
    >
      <Box className="top-section">
        <img
          src={introductionImage}
          alt="Introduction"
          className="introduction-image"
        />
        <Box className="introduction-text">
          <Typography variant="h1">
            {t("label.getStartedWithProjectTool")}
          </Typography>
          <Typography>{t("label.introductionDescriptionSection1")}</Typography>
          <Typography>{t("label.introductionDescriptionSection2")}</Typography>
          <Button variant="green-contained" onClick={onCloseDialog}>
            {t("label.start")}
          </Button>
        </Box>
      </Box>
      <Typography variant="h1">{t("label.exampleProjects")}</Typography>
      <ErrorBoundary FallbackComponent={AlertErrorBoundary}>
        <Suspense fallback={<ExampleProjectsSkeleton />}>
          <ExampleProjects />
        </Suspense>
      </ErrorBoundary>

      <IconButton className="close-button" onClick={onCloseDialog}>
        <Clear />
      </IconButton>
    </StyledDialog>
  );
}

const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    padding: ${({ theme }) => theme.spacing(4)};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(4)};
  }

  .MuiTypography-h1 {
    font-size: 22px;
  }
  .top-section {
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing(4)};
  }
  .introduction-text {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
  }
  .MuiButton-root {
    width: fit-content;
  }

  .close-button {
    position: absolute;
    top: ${({ theme }) => theme.spacing(1.5)};
    right: ${({ theme }) => theme.spacing(1.5)};
  }

  .introduction-image {
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }

  .project-section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing(4)};
    /* justify-content: space-evenly; */
  }

  .open-link {
    font-weight: 700;
    font-size: 14px;
    margin-right: ${({ theme }) => theme.spacing(2)};
  }
`;
